import "./AlarmEvents.html";
import "./AlarmEvents.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AlarmEventsComponentController from "./AlarmEventsComponentController";

export class AlarmEventsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
            timeZone: "<",
        };
        this.controller = AlarmEventsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/AlarmEvents/AlarmEvents.html";
    }
}

module("mmManagePortal").component("mmAlarmEvents", new AlarmEventsComponent());
